import { useBoolVariation } from "@launchdarkly/react-sdk";

/**
 * Boolean LaunchDarkly flag for the current user and selected studio. Returns `defaultValue`
 * until flags load, when the flag doesn't exist, or when LaunchDarkly isn't configured.
 * Only flags marked "Available to client-side SDKs" in LaunchDarkly reach the browser.
 */
export const useFeatureFlag = (flagKey: string, defaultValue = false) =>
  useBoolVariation(flagKey, defaultValue);
